export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 2-1_06.0881bb04.jpg";